import React, { JSX } from 'react'
import {
  CancelSharp,
  CheckCircle,
  CloseSharp,
  Error,
  Info,
  Warning,
} from '@mui/icons-material'
import { Alert, AlertColor, Box, IconButton } from '@mui/material'
import { NotificationProps } from 'components/notification-message/constants/type-form-notification-message'

const NotificationMessage = ({
  icon,
  title,
  description,
  onRequestClose,
  hideCloseButton,
  style,
}: NotificationProps) => {
  const defaultIcons: Record<AlertColor, JSX.Element> = {
    success: <CheckCircle sx={{ color: '#1de9b6', fontSize: 35 }} />,
    error: <CancelSharp sx={{ color: '#fe4849', fontSize: 35 }} />,
    info: <Info sx={{ color: '#01B6F5', fontSize: 35 }} />,
    warning: <Error sx={{ color: '#FFCC00', fontSize: 35 }} />,
  }
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 10,
        right: 10,
        height: 'auto',
        maxHeight: '85px',
        zIndex: 9999,
        width: '310px',
        bgcolor: 'white',
        borderRadius: 4,
        border: '1px solid #b2b2b277',
        boxShadow: '0.1px 1px 5px #6e6e6e58',
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        ...style,
      }}
    >
      <>
        <Box sx={{ mt: 1, ml: 0.5 }}>
          {typeof icon === 'string' ? defaultIcons[icon as AlertColor] : icon}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              mt: 1,
              ml: 0.8,
              fontSize: 16,
              fontFamily: 'sans-serif',
              overflowWrap: 'break-word',
              wordBreak: 'break-all',
              whiteSpace: 'pre-line',
              hyphens: 'auto',
            }}
          >
            {title}
            {!hideCloseButton && (
              <IconButton
                sx={{
                  ml: 1,
                  height: 12,
                  width: 12,
                  // display: 'flex',
                  position: 'absolute',
                  right: 10,
                }}
                onClick={onRequestClose}
              >
                <CloseSharp sx={{ fontSize: 17 }} />
              </IconButton>
            )}
          </Box>
          <Box
            sx={{
              mt: 0.2,
              ml: 0.8,
              mr: 2,
              fontSize: 14.5,
              color: '#4e4e4eff',
              fontFamily: 'sans-serif',
              overflowWrap: 'break-word',
              wordBreak: 'break-all',
              whiteSpace: 'pre-line',
              hyphens: 'auto',
            }}
          >
            {description}
          </Box>
        </Box>
      </>
    </Box>
  )
}

export default NotificationMessage
